export default function () {
  return {
    type: null,
    licencePlate: null,
    email: '',
    duration: 1,
  };
}
